import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-full flex-col',
    title: 'heading-2xl lg:heading-3xl mb-5 lg:mb-3',
    description: 'heading-xs lg:heading-m mb-6 font-light lg:mb-10',
    list: 'mb-auto flex flex-col gap-5',
    item: 'bg-blue-light flex items-start justify-between gap-4 overflow-hidden rounded-[8px] p-4 sm:p-5',
    itemContent: 'min-w-0 flex-1',
    itemTitle: 'heading-s-bold mb-1 block',
    itemDescription: 'heading-xs leading-[1.45] font-light',
    toggle: 'shrink-0 pt-0.5',
    buttons: 'mt-8 flex gap-3 max-sm:flex-col-reverse',
    button: 'w-full',
    cancel: ''
  }
});
